// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3lzj4","header":"ReportDetails_header__3nYDU","title":"ReportDetails_title__2SkiY","left":"ReportDetails_left__PEFnC"};